import { useNavigate, useRouterState } from '@tanstack/react-router';
import { setOrgId } from './org';

/** Switching client keeps the current page unless it shows one record of the previous client. */
export function useOpenClient() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (st) => st.location.pathname });
  return (id: string, opts: { toDashboard?: boolean } = {}) => {
    setOrgId(id);
    if (opts.toDashboard || /[0-9a-f]{8}-[0-9a-f]{4}-/.test(pathname))
      void navigate({ to: '/dashboard' });
  };
}
